export default "__VITE_ASSET__CayU02kt__"